import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const SelectorModulos = ({ 
  value = '',
  onChange,
  disabled = false,
  isDarkMode = false
}) => {
  const [modulos, setModulos] = useState([]);
  const [loading, setLoading] = useState(false);

  // Cargar módulos al montar el componente
  useEffect(() => {
    loadModulos();
  }, []);

  const loadModulos = async () => {
    setLoading(true);
    try {
      const token = sessionStorage.getItem('mapasac_access_token');
      const response = await fetch('/api/modulos?limit=100', {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const result = await response.json();
        // Filtrar solo módulos activos
        //const modulosActivos = result.data.modulos.filter(modulo => modulo.activo === 1);
        //setModulos(modulosActivos);

        // Mostrar todas los modulos (activos e inactivos)
        setModulos(result.data.modulos || []);
      }
    } catch (error) {
      console.error('Error cargando módulos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const moduloId = e.target.value;
    onChange(moduloId);
  };

  const selectClass = `w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none ${
    isDarkMode 
      ? 'bg-gray-700 border-gray-600 text-gray-400' 
      : 'bg-white border-gray-300 text-gray-900'
  } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`;

  return (
    <div>
      <div className="relative">
        <select
          value={value || ''}
          onChange={handleChange}
          disabled={disabled || loading}
          className={`${selectClass} ${isDarkMode ? (value ? 'text-white' : 'text-gray-400') : ''}`}
        >
          <option value="">
            {loading ? 'Cargando módulos...' : 'Seleccionar módulo'}
          </option>
          {modulos.map(modulo => (
            <option key={modulo.idmodulos} value={modulo.idmodulos}>
              {modulo.codigo} - {modulo.nombre}
            </option>
          ))}
        </select>
        <ChevronDown className="absolute right-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400 pointer-events-none" />
      </div>
    </div>
  );
};

export default SelectorModulos;